var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-change-indicator",class:`chart-change-indicator--${_vm.color}`},[(isFinite(_vm.value))?_c('span',[_vm._v("\n        "+_vm._s(_vm.sign)+_vm._s(_vm.value)+"%\n    ")]):_c('span',[_vm._v("\n        0%\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }